
  import EventCardGeneral from '@/components/EventCardGeneral.vue';
  import ShimmerEffect from "@/components/ShimmerEffect.vue";
  export default {
    components: {
      EventCardGeneral,
      ShimmerEffect
    },
    head() {
      return {
        title: this.title,
        meta: [{
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
        {
          hid: "twitter:title",
          property: "twitter:title",
          content: this.title,
        },
        {
          hid: "twitter:description",
          property: "twitter:description",
          content: this.description,
        },

        ],
        bodyAttrs: {
          class: this.showHelpModal ? 'pass-modal-open' : ''
        }
      };

    },
    data() {
      return {
        title: 'Events in ' + this.$route.params.state + ' - Events in ' + this.$route.params.state + ' today | upcoming events in ' + this.$route.params.state,
        description: 'Events in ' + this.$route.params.state + ', events in '+ this.$route.params.state + ' today, upcoming events in '+ this.$route.params.state + ', events in '+ this.$route.params.state + ' this weekend, events in '+ this.$route.params.state + ' this week, music events in '+ this.$route.params.state + ' today, party events in '+ this.$route.params.state + ' today, party events in ' + this.$route.params.state + ', events in '+ this.$route.params.state + ' tomorrow',
        categoriesData: null,
        skip: 0,
        page: 1,
        totalNumberOfpages: 0,
        busy: false,
        productObj: [],
        listings: {},
        schemaData: [],
        loading: true,
        listingLoading: true,

        //New code
        categorySlug: null,
        stateSlug: null,
        selectedState: null,
        activiteStatesList: [],
        popularEvents: null,
        popularEventsLoading: true,
        eventCategoryModal: false,
        categoriesLoading: true,

      }
    },

    async validate({
      params,
      store
    }) {
      // await operations
      if (params.slug != (null || "")) {
        this.categorySlug = params.category;
        this.stateSlug = params.state;
        this.selectedState = params.state;
        return true // if the params are valid
      } else {
        return false // will stop Nuxt.js to render the route and display the error page
      }
    },
    created() {
      this.categorySlug = this.$route.params.category.replace('-events','');
      this.stateSlug = this.$route.params.state;
      this.selectedState = this.stateSlug
      this.title = this.categorySlug + ' events in ' + this.$route.params.state + ' - ' + this.categorySlug + ' events in ' + this.$route.params.state + ' today | upcoming '+ this.categorySlug +' events in ' + this.$route.params.state;
      this.description = this.categorySlug + ' events in ' + this.$route.params.state + ', ' + this.categorySlug + ' events in '+ this.$route.params.state + ' today, upcoming ' + this.categorySlug +' events in '+ this.$route.params.state + ', ' + this.categorySlug + ' events in '+ this.$route.params.state + ' this weekend, ' + this.categorySlug + ' events in '+ this.$route.params.state + ' this week, ' + this.categorySlug + ' events in '+ this.$route.params.state + ' tomorrow'
    },

    mounted() {
      this.categorySlug =  this.categorySlug.replace('-events','');
      this.getData();
      let pagination = (this.page - 1) * 8;
      if (pagination < 0) {
        pagination = 0;
      }
      this.getListings(pagination);
    },

    methods: {
      async getData() {
        this.categoriesData = await fetch(this.$config.fetchUrl + '/api/activityTypes/app/getTypeDetails/events/')
        .then(res => res.text());
      this.categoriesData = this.getCryptKey(this.categoriesData);
      this.categoriesLoading = false;
        this.activiteStatesList = await fetch(this.$config.fetchUrl + '/api/states/app/getAllActiveStates/')
          .then(res => res.text());
        this.activiteStatesList = this.getCryptKey(this.activiteStatesList);
        this.popularEvents = await fetch(this.$config.fetchUrl + `/api/events/getFeaturedEventsOfCategoryInCity/${this.stateSlug}/${this.categorySlug}`)
          .then(res => res.text());
        this.popularEvents = this.getCryptKey(this.popularEvents);
       if(!Array.isArray(this.popularEvents)){
        this.popularEvents = null;
       }
        this.popularEventsLoading = false
      },

      cityDropdownClicked(event) {
        if (event && event.target.value) {
          this.$router.push({
            path: `/${event.target.value}/events/${this.categorySlug}-events`
          })
        }
      },

      categoryBtnClicked(item) {
      if (item && item.slug) {
        this.eventCategoryModal = false;
        this.$router.push({
          path: `/${this.stateSlug}/events/${item.slug}-events`
        })
      }
    },

      getSlugTitle(title){
        return title.replace( /-/g, " " );
      },

      getStateTitle(title){
        if(this.activiteStatesList && this.activiteStatesList.states){
        var stateTitle = this.activiteStatesList.states.filter(x => x.slug == title);
        return stateTitle && stateTitle.length > 0 ? stateTitle[0].name : '';
        }
        return ''
      },

      loadMore() {
        this.busy = false;
        if (this.listings.isMoreDataAvailable) {
          this.busy = true;
          setTimeout(() => {
            this.page++
            this.callback(this.page)
          }, 1000);
        }
      },

      // callback for the pagination plugin
      callback: function (page) {
        this.page = page;
        let pagination = (page - 1) * 8;
        if (pagination < 0) {
          pagination = 0;
        }
        this.getListings(pagination);
      },

      // TO get SUBSCRIPTIONS using pagination
      getListings(skip, year = null, month = null, categories = null, queryStr = null) {
        //if no categories are selected we can mkae a get request of the form /api/posts/app/getPostsOfType/places/:query/:pagination/:categories/:sortBy
        //the reason is POST requests cant be cached but get requests can so the data will load very fast when user hits back from a detail page
        //this.listingLoading = true;

        // AXIOS api call to add review api
        this.$axios
          .get(
            `/api/events/getAllUpcomingEventsOfCategoryInCity/${this.stateSlug}/${this.categorySlug}/${skip}`
          )
          .then((response) => {
            let value = this.getCryptKey(response.data);
            this.productObj.push(...value.events)
            this.listings = value;
            this.schemaData = this.listings && this.listings.events ? this.listings.events : [];
            if (skip == 0) {
              this.page = 1;

            }
            this.totalNumberOfpages = Math.ceil(this.listings.totalCount / 12);
            this.$nextTick(() => {
              this.busy = false;
              this.listingLoading = false;
            });
          })
          .catch((error) => {
            this.$nextTick(() => {
              this.listingLoading = false;
            });
          })
          .finally(() => {
            this.$nextTick(() => {
              this.listingLoading = false;
            });
          });
      }

    }

  }
  